module.exports = __webpack_public_path__ + "static/media/avicollect.cc7ed1dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/avicollect.png
// module id = 570
// module chunks = 0